var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Banner'),_c('Ecosystem'),_c('ValueSymbiosis'),_c('OrderSystem'),_c('OrderTypes'),_c('BecomeProvider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }